import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-trips-itinerary-exclusion-item',
    templateUrl: './trips-itinerary-exclusion-item.component.html',

    standalone: true,
})
export class TripsItineraryExclusionItemComponent implements OnInit {
    @Input() exclusion: string;
    constructor() {}

    ngOnInit(): void {}
}
